export const getDataByPage = (
  data: Array<any>,
  page: number,
  rowsPerPage: number
) => {
  return data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
};

export const copyToClipboard = async (text: string) => {
  if ("clipboard" in navigator) {
    await navigator.clipboard.writeText(text);
  } else {
    document.execCommand("copy", true, text);
  }
  return;
};
